var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 11.5a8.38 8.38 0 0 1-2.4 5.9 8.5 8.5 0 0 1-6 2.6 8.38 8.38 0 0 1-5.9-2.4L3 21l2.4-3.7A8.38 8.38 0 0 1 3 11.5 8.5 8.5 0 0 1 5.4 5.6a8.5 8.5 0 0 1 6-2.6 8.5 8.5 0 0 1 6 2.6 8.5 8.5 0 0 1 2.6 6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10h.01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10h.01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10h.01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.d6c418ea477ad8e82e0984d5f3780bf8.svg";
export { ForwardRef as ReactComponent };